import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, makeStyles } from '@material-ui/core'

import { FONTS } from 'styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: theme.spacing(8),
  },
  button: {
    fontFamily: FONTS.GOTHAM_LIGHT,
    fontSize: '18px',
    backgroundColor: theme.palette.primary.main,
    textTransform: 'capitalize',
    height: '45px',
    borderRadius: '10px',
    width: 200,
    color: theme.palette.background.default,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}))

export const MenuInvoice: React.FC = () => {
  const classes = useStyles()
  const history = useHistory()

  const handleClick = () => {
    history.push('/invoice/scan')
  }

  const checkInvoice = () => {
    history.push('/invoice/check')
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 30 }}>
      <Button variant="contained" color="primary" className={classes.button} onClick={handleClick}>
        Cargar Factura
      </Button>
      <Button variant="contained" color="primary" className={classes.button} onClick={checkInvoice}>
        Chequear Factura
      </Button>
    </div>
  )
}
